import Box from "@mui/material/Box"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { FRONTEND_LINKS } from "../../../Constants/FrontendLinks"
import { MobergFontSize } from "../../../Components/MobergFont/MobergFont"
import { MobergButton, MobergButtonShape, MobergButtonVariant, MobergTheme } from "../../../Moberg"
import { MdDevices, MdFileDownload } from "react-icons/md"
import { URL_PARAMS, MODAL_TYPE, RM_STEPS } from "../../RemoteMonitoring/constants"
import { useAuthProvider } from "../../../Providers/AuthProvider"
import { Deployment, useEnvironmentVariablesProvider } from "../../../Providers/EnvironmentVariablesProvider"

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    }
}

export default function PatientTabs() {
    const navigate = useNavigate()
    const location = useLocation()
    const authProvider = useAuthProvider()
    const { deployment, environmentVariables } = useEnvironmentVariablesProvider()
    const isClinical = deployment === Deployment.CLINICAL
    const exportFeatureEnabled = isClinical && !!environmentVariables?.FEATURE_FLAG_EXPORT

    const getCurrentTabValue = () => {
        if (location.state?.admission_status === "admitted") {
            return 0
        } else if (location.state?.admission_status === "discharged") {
            return 1
        }
        
        const urlParams = new URLSearchParams(location.search)
        const admissionStatus = urlParams.get('admission_status')
        
        if (admissionStatus === "admitted") {
            return 0
        } else if (admissionStatus === "discharged") {
            return 1
        } else if (admissionStatus === "all") {
            return 2
        }
        
        return 0
    }

    const [value, setValue] = useState(getCurrentTabValue())

    useEffect(() => {
        setValue(getCurrentTabValue())
    }, [location])

    const handleChange = (event, newValue) => {
        setValue(newValue)
        if (newValue === 0) {
            navigate(FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.MAIN + "?admission_status=admitted")
        } else if (newValue === 1) {
            navigate(FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.MAIN + "?admission_status=discharged")
        }
        else {
            navigate(FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.MAIN + "?admission_status=all")
        }
        
    }

    const tabStyles = {
        textTransform: "none",
        fontSize: MobergFontSize.LARGE,
        borderRadius: '4px',
        color: 'var(--text-secondary-color)',
        '&.Mui-selected': {
            color: 'var(--color-accent-interactive)',
        },
    }

    return (
        value !== null && (
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                paddingLeft: '30px', 
                paddingRight: '30px',
                paddingTop: '10px'
            }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    sx={{
                        '& .MuiTabs-indicator': {
                            backgroundColor: 'var(--color-accent-interactive)',
                        },
                    }}
                >
                    <Tab label="Admitted" {...a11yProps(0)} sx={{ marginLeft: '-2px', ...tabStyles }} disableRipple />
                    <Tab label="Discharged" {...a11yProps(1)} sx={{ ...tabStyles }} disableRipple />
                    <Tab label="All" {...a11yProps(2)} sx={{ ...tabStyles }} disableRipple />
                </Tabs>
                <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    {exportFeatureEnabled && authProvider.permissions?.['export:view'] && (
                        <MobergButton
                            variant={MobergButtonVariant.OUTLINE}
                            theme={MobergTheme.BLUE}
                            shape={MobergButtonShape.RECTANGLE}
                            onClick={() => {
                                const urlParams = new URLSearchParams(location.search)
                                urlParams.set(URL_PARAMS.MODAL, MODAL_TYPE.EXPORTS)
                                const newUrl = `${location.pathname}?${urlParams.toString()}`
                                window.history.replaceState(null, '', newUrl)
                                window.dispatchEvent(new Event('modalUrlChange'))
                            }}
                            disabled={false}
                        >
                            <MdFileDownload size={18} />
                            Exports
                        </MobergButton>
                    )}
                    <MobergButton
                        variant={MobergButtonVariant.OUTLINE}
                        theme={MobergTheme.BLUE}
                        shape={MobergButtonShape.RECTANGLE}
                        onClick={() => {
                            const urlParams = new URLSearchParams(location.search)
                            urlParams.set(URL_PARAMS.MODAL, MODAL_TYPE.REMOTE_MONITORING)
                            urlParams.set(URL_PARAMS.STEP, RM_STEPS.SELECT_GATEWAY)
                            const newUrl = `${location.pathname}?${urlParams.toString()}`
                            // Use history.replaceState to update URL without triggering navigation
                            window.history.replaceState(null, '', newUrl)
                            // Manually trigger the effect in DataVisualize by dispatching a custom event
                            window.dispatchEvent(new Event('modalUrlChange'))
                        }}
                        disabled={false}
                    >
                        <MdDevices size={18} />
                        View MCP Devices
                    </MobergButton>
                </Box>
            </Box>
        )
    )
}
